import getCdnImg from '@/shared/cdn/getCdnImg';

const positionImages: Record<string, string> = {
  '1': getCdnImg('icons/gold.svg'),
  '2': getCdnImg('icons/silver.svg'),
  '3': getCdnImg('icons/bronze.svg'),
};

export default positionImages;
